import React from "react";

function TimeStampIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8335 5.00016C10.8335 4.53993 10.4604 4.16683 10.0002 4.16683C9.53992 4.16683 9.16683 4.53993 9.16683 5.00016V10.0002C9.16683 10.3158 9.34516 10.6044 9.62748 10.7455L12.9608 12.4122C13.3725 12.618 13.873 12.4512 14.0789 12.0395C14.2847 11.6279 14.1178 11.1273 13.7062 10.9215L10.8335 9.48513V5.00016Z"
        fill="#2D3648"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0002 0.833496C4.93755 0.833496 0.833496 4.93755 0.833496 10.0002C0.833496 15.0628 4.93755 19.1668 10.0002 19.1668C15.0628 19.1668 19.1668 15.0628 19.1668 10.0002C19.1668 4.93755 15.0628 0.833496 10.0002 0.833496ZM2.50016 10.0002C2.50016 5.85803 5.85803 2.50016 10.0002 2.50016C14.1423 2.50016 17.5002 5.85803 17.5002 10.0002C17.5002 14.1423 14.1423 17.5002 10.0002 17.5002C5.85803 17.5002 2.50016 14.1423 2.50016 10.0002Z"
        fill="#2D3648"
      />
    </svg>
  );
}

export default TimeStampIcon;
